import { useTranslation } from 'react-i18next';
import { whyIcons } from '@/mocks/salonData';

interface WhyItem {
  title: string;
  desc: string;
}

export default function WhySection() {
  const { t } = useTranslation();
  const items = t('why.items', { returnObjects: true }) as WhyItem[];

  return (
    <section className="py-16 md:py-24 bg-dark-950 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div
          className="w-full h-full"
          style={{
            backgroundImage: `radial-gradient(circle at 1px 1px, rgba(255,255,255,0.3) 1px, transparent 0)`,
            backgroundSize: '40px 40px',
          }}
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-champagne-400 text-xs font-medium tracking-[0.2em] uppercase mb-3">
            {t('why.title')}
          </p>
          <h2 className="font-display text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-3">
            {t('why.title')}
          </h2>
          <p className="text-white/50 text-base md:text-lg max-w-xl mx-auto">
            {t('why.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {items.map((item, idx) => (
            <div
              key={idx}
              className="group p-6 md:p-8 rounded-2xl bg-white/5 backdrop-blur-sm border border-white/10 hover:bg-white/10 hover:border-champagne-500/30 transition-all text-center"
              style={{ animationDelay: `${idx * 100}ms` }}
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-champagne-500/10 text-champagne-400 mx-auto mb-4 group-hover:bg-champagne-500/20 transition-colors">
                <i className={`${whyIcons[idx].icon} text-xl md:text-2xl`} />
              </div>
              <h3 className="text-white font-semibold text-sm md:text-base mb-2">
                {item.title}
              </h3>
              <p className="text-white/50 text-xs md:text-sm leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}